import {
  Stack,
  FormControlLabel,
  Checkbox,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { LabelStyle } from "../../Common/styles/form";
import { useState } from "react";

const profileAttributeTypes = [
  { key: "firstName", label: "First Name" },
  { key: "lastName", label: "Last Name" },
  { key: "gender", label: "Gender" },
  { key: "dob", label: "Date of Birth" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "occupation", label: "Occupation" },
  { key: "line1", label: "Address Line 1" },
  { key: "line2", label: "Address Line 2" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "country", label: "Country" },
  { key: "zipcode", label: "Zipcode" },
] as const;

const addressAttributeTypes = [{ key: "address", label: "Address" }] as const;

const menuOptions = [...profileAttributeTypes, ...addressAttributeTypes];

type Props = {
  question: any;
  onChange: Function;
  isPreview: boolean;
  type: string;
};

const ProfileAttribute = ({ question, onChange, isPreview, type }: Props) => {
  const [showCheckbox, setShowCheckbox] = useState<boolean>(
    !!question.profileAttribute
  );
  const [selectedAttribute, setSelectedAttribute] = useState<string>(
    question.profileAttribute
      ? menuOptions.map((type) => type.key).includes(question.profileAttribute)
        ? question.profileAttribute
        : ""
      : ""
  );

  const profileAttributeChange = (val: any) => {
    setSelectedAttribute(val);
    onChange("profileAttribute", val);
  };

  return (
    <Stack gap={2}>
      <FormControlLabel
        disabled={isPreview}
        control={
          <Checkbox
            checked={showCheckbox}
            onChange={(e) => {
              setShowCheckbox(e.target.checked);
              if (!e.target.checked) {
                setSelectedAttribute("");
                onChange("profileAttribute", "");
              }
            }}
          />
        }
        label={
          <Typography variant="subtitle1" fontWeight="medium">
            Update to profile
          </Typography>
        }
      />
      {showCheckbox && (
        <Stack>
          <Typography sx={LabelStyle}>Profile variable</Typography>
          <Select
            value={selectedAttribute}
            onChange={(e) => profileAttributeChange(e.target.value)}
            placeholder="Select attribute"
            disabled={isPreview}
            displayEmpty
          >
            <MenuItem value="" disabled sx={{ display: "none" }}>
              Select attribute
            </MenuItem>
            {(type === "address"
              ? addressAttributeTypes
              : profileAttributeTypes
            ).map((item: { key: string; label: string }) => (
              <MenuItem value={item.key} key={item.key}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      )}
    </Stack>
  );
};

export default ProfileAttribute;
